import { WORKSHOP_2026_PATH } from '../services/workshop2026Service';

/** Public URL encoded in the flyer QR code. */
export const WORKSHOP_FLYER_PUBLIC_URL = 'https://recoverycommons.com/2026-workshop';

export const WORKSHOP_FLYER_PATH = `${WORKSHOP_2026_PATH}/flyer`;

export function workshopFlyerUrl(origin = typeof window !== 'undefined' ? window.location.origin : 'https://recoverycommons.com'): string {
  return `${origin}${WORKSHOP_FLYER_PATH}`;
}

/** Open flyer in a new tab so the flyer page can close itself when the user goes back. */
export function openWorkshopFlyerTab(): void {
  if (typeof window === 'undefined') return;
  window.open(workshopFlyerUrl(), '_blank');
}
